import { createApp, watch } from 'vue'
import App from './App.vue'
import store from './store/'
//引入路由
import router from "@/router/index";
//引入element plus、css、中文
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// eslint-disable-next-line no-unused-vars
import * as ElIcons from '@element-plus/icons'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import Vant from 'vant';
import 'vant/lib/index.css'
//语言切换
import i18n from './i18n.js'

export const app = createApp(App)
app.use(store)
app.use(ElementPlus, {locale: zhCn})
app.use(Vant);
app.use(router)
app.use(i18n);
app.mount('#app')

function setDocumentTitle() {
  document.title = i18n.global.t('mvp.ddrttx')
}

setDocumentTitle()

watch(
  () => i18n.global.locale,
  () => {
    setDocumentTitle()
  }
)